import 'jquery-inview/jquery.inview.min';

export default {
  init() {
    // JavaScript to be fired on all pages

    $('.owl-galerie').owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
    });

    /* LazyLoading Img */
    window.img_lazyloading = function() {
      var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));

      if ('IntersectionObserver' in window) {
        var lazyImageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if(entry.isIntersecting) {
              var lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              if (lazyImage.dataset.srcset) {
                lazyImage.srcset = lazyImage.dataset.srcset;
              }
              lazyImage.classList.remove('lazy');
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      } else {
        $('img.lazy').each(function(){
          $(this).attr('src', $(this).attr('data-src'));
        });
      }

      // Bg img
      var BGlazyImages = [].slice.call(document.querySelectorAll('.bg-lazy'));

      if ('IntersectionObserver' in window) {
        var BGlazyImageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if(entry.isIntersecting) {
              var lazyImage = entry.target;
              lazyImage.style.backgroundImage = 'url('+lazyImage.dataset.src+')';
              lazyImage.classList.remove('bg-lazy');
              BGlazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        BGlazyImages.forEach(function(lazyImage) {
          BGlazyImageObserver.observe(lazyImage);
        });
      } else {
        $('.bg-lazy').each(function(){
          $(this).css('background-image', 'url('+$(this).attr('data-src')+')');
        });
      }
    };
    // eslint-disable-next-line no-undef
    img_lazyloading();
    /* END LazyLoading Img */

    /* Menu */
    $('.menu-trigger').click(function(){
      var classes = $(this).find('.nav-icon').attr('class');
      if(classes.indexOf('open') != -1){
        $('.sidenav').removeClass('open');
        $('.overlay-fullsize').css('visibility', 'hidden');
        $(this).find('.nav-icon').removeClass('open');
        $('body').removeClass('overflow-hidden');
      }else {
        $('.sidenav').addClass('open');
        $('.overlay-fullsize').css('visibility', 'visible');
        $(this).find('.nav-icon').addClass('open');
        $('body').addClass('overflow-hidden');
      }
      return false;
    });
    $('.overlay-fullsize').click(function(){
      $('.menu-trigger').trigger('click');
    });
    $(document).ready(function() {
      var header_height = $('header').outerHeight();
      $('.sidenav').css('top', header_height + 'px');
      $('.sidenav').css('max-height', 'calc(100% - ' + header_height + 'px)');
    });
    /* END Menu */

    /* Notif Cookies */
    $('.notif a').click(function() {
      $.ajax({
        // eslint-disable-next-line no-undef
        url: ajax_object.ajaxurl,
        type: 'POST',
        data: {'action': 'hide_notif'},
        success: function(  ){
          $('.notif').addClass('close');
        },
      });
      return false;
    });
    /* END Notif Cookies */

    /* INPUT */
    $('.input').focus(function() {
      $(this).parent('.form-group').find('label').addClass('active'); //hide label of clicked item
    }).blur(function() {
      var val = $(this).val();
      if( val == '' ) {
        $(this).parent('.form-group').find('label').removeClass('active');
      }
    });
    /* END INPUT */

    /* Témoignages */
    $('.owl-testimonials').owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
    });
    /* END Témoignages */

    /* Blockquote */
    $('blockquote').each(function() {
      var text = $(this).text();
      console.log('blockquote text', text);
      $(this).prepend('<span class="blockquote-svg first"><i class="ph-light ph-quotes"></i></span>');
      $(this).append('<span class="blockquote-svg last"><i class="ph-light ph-quotes"></i></span>');
    });
    /* END Blockquote */

    /* Section Number InView */
    $('body').ready(function() {
      $('.chiffres-divblock').on('inview', function(event, isInView) {
        var scrollspy = $(this).attr('data-scrollspy');
        if (isInView && scrollspy == '0') {
          // element is now visible in the viewport
          $('.number').each(function () {
            $(this).prop('Counter',0).animate({
              Counter: $(this).text(),
            }, {
              duration: 4000,
              easing: 'swing',
              step: function (now) {
                $(this).text(toArabic(Math.ceil(now)));
              },
            });
          });
          $(this).attr('data-scrollspy', '1');
        }
      });
    });

    function toArabic(x) {
      return x.toLocaleString('cs-CZ');
    }
    /* END Section Number InView */

    window.MapStyle = function() {
      var styles = [
        {
            'featureType': 'administrative',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#444444',
                },
            ],
        },
        {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#f2f2f2',
                },
            ],
        },
        {
            'featureType': 'landscape',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'visibility': 'on',
                },
                {
                    'hue': '#e11803',
                },
            ],
        },
        {
            'featureType': 'landscape.man_made',
            'elementType': 'geometry',
            'stylers': [
                {
                    'lightness': '100',
                },
            ],
        },
        {
            'featureType': 'landscape.man_made',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off',
                },
            ],
        },
        {
            'featureType': 'landscape.natural',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'lightness': '100',
                },
            ],
        },
        {
            'featureType': 'landscape.natural',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off',
                },
            ],
        },
        {
            'featureType': 'landscape.natural.landcover',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'visibility': 'on',
                },
            ],
        },
        {
            'featureType': 'landscape.natural.terrain',
            'elementType': 'geometry',
            'stylers': [
                {
                    'lightness': '100',
                },
            ],
        },
        {
            'featureType': 'landscape.natural.terrain',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'visibility': 'off',
                },
                {
                    'lightness': '23',
                },
            ],
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off',
                },
            ],
        },
        {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': -100,
                },
                {
                    'lightness': 45,
                },
            ],
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified',
                },
            ],
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#0f4c66',
                },
            ],
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'labels.icon',
            'stylers': [
                {
                    'visibility': 'off',
                },
            ],
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off',
                },
            ],
        },
        {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#0f4c66',
                },
                {
                    'visibility': 'on',
                },
            ],
        },
        {
            'featureType': 'water',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'visibility': 'on',
                },
                {
                    'color': '#cccccc',
                },
            ],
        },
        {
            'featureType': 'water',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off',
                },
            ],
        },
    ];
      return styles;
    };
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js